import { updateField } from './updateField';
export const updateOptionsLabel = ({
  formField,
  updateCallback
}) => (val, idx) => {
  const newOptions = formField.options;
  newOptions[idx].label = val;
  updateCallback(updateField(formField, 'options', newOptions));
};
export const handleUpdateLabel = ({
  idx = 0,
  formField = {},
  value = '',
  updateCallback
}) => updateOptionsLabel({
  formField,
  updateCallback
})(value, idx);